import upsell from "../upsell"
import { TrackingManager } from "../../../../../lib/common/js/services/tracking/trackingManager"

export default (getView) =>
  ({ nextStepPath, upsellOfferType }) => ({
    ...getView(nextStepPath),
    ...upsell(upsellOfferType),

    statusToTrack: "PURCHASE",
    internalTracker: new TrackingManager(
      window.trackingConfig.enabledTrackingServices,
      pipelineConfig,
    ),

    init() {
      this.commonInit()
    },

    onInit() {
      this.initUpsell()
    },

    handleButton() {
      this.internalTracker.trackClick({ clickName: "Continue Clicked" })
      this.goToNextUpsellOffer()
    },
  })
